<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet tile height="54" class="d-flex">
        <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn outlined class="ma-2" color="grey darken-2" @click="updateActiveDay()">
          Azi - {{ displayCurrentMonth }} {{ new Date().getFullYear() }}
        </v-btn>

        <v-btn outlined class="ma-2" color="grey darken-2" @click="dateDialog = true">
          Alege ziua
        </v-btn>

        <v-dialog v-model="dateDialog" max-width="320">
          <v-card>
            <v-card-title class="headline"> Alege o zi </v-card-title>

            <v-card-text>
              <v-date-picker v-model="pickedDate" :first-day-of-week="1" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dateDialog = false"> Anulează </v-btn>
              <v-btn text color="primary" @click="goToPickedDate"> OK </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <v-btn icon class="ma-2" @click="$refs.calendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-sheet>
      <v-sheet height="700">
        <v-calendar ref="calendar" v-model="$store.state.tasks.activeDay" :weekdays="weekday" :type="type"
          :events="events" :event-overlap-mode="mode" :event-overlap-threshold="30" :event-color="getEventColor"
          :event-ripple="false" @change="getEvents" @click:event="showEvent" :event-more="true"
          :interval-format="intervalFormatter">
          <template v-slot:event="{ event, timed }">
            <div class="v-event-draggable">
              <strong>{{ event.name }}</strong>
              <br />
              {{ formatAddress(event) }}
            </div>
            <div v-if="timed" class="v-event-drag-bottom" @mousedown.stop="extendBottom(event)"></div>
          </template>
        </v-calendar>
        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
          <v-card color="grey lighten-4" min-width="250px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon @click="editItem">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="gotoClient" v-if="selectedEvent.clientId">
                <v-icon>supervisor_account</v-icon>
              </v-btn>
              <v-btn icon @click="gotoCreateClient" v-if="!selectedEvent.clientId">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn icon @click="selectedOpen = false">
                <v-icon>cancel</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <p>
                <b class="mt-2 mr-2">Telefon:</b>
                <a :href="phoneHref" v-html="phone"></a>
              </p>

              <p>
                <b class="mt-2 mr-2">Adresa:</b>
                <span v-html="address"></span>
              </p>

              <p>
                <b class="mt-2 mr-2">Descriere:</b>
                <span v-html="selectedEvent.description"></span>
              </p>

              <p>
                <span v-html="specialClient"></span>
              </p>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-sheet>
      <v-sheet tile>
        <SearchTask />

        <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="mod afisare"></v-select>
        <v-select v-model="mode" :items="modes" dense outlined hide-details label="mod suprapuneri"
          class="ma-2"></v-select>
        <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="saptamana"
          class="ma-2"></v-select>
      </v-sheet>

      <v-layout justify-center>
        <router-link to="/tasks/create">
          <v-btn color="red" fab small dark fixed bottom justify-center>
            <v-icon>add</v-icon>
          </v-btn>
        </router-link>
      </v-layout>
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations } from 'vuex';
import { TaskStoreModel } from '../../store/modules/tasks';
import { PERMISSION_LEVEL_ADMIN } from '../../utils/permissions';
import SearchTask from './SearchTask.vue';

export default {
  name: 'ListTasks',
  components: {
    SearchTask,
  },
  data: () => ({
    type: 'week',
    types: ['month', 'week', 'day', '4day'],
    weekdays: [
      { text: 'Luni - Vineri', value: [1, 2, 3, 4, 5] },
      { text: 'Luni - Duminica', value: [1, 2, 3, 4, 5, 6, 0] },
    ],
    mode: 'column',
    modes: ['stack', 'column'],
    weekday: [1, 2, 3, 4, 5],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: {},
    events: [],
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,

    dateDialog: false,
    pickedDate: '',
  }),

  computed: {
    phone() {
      return this.selectedEvent?.phone || this.selectedEvent?.client?.phone;
    },

    phoneHref() {
      return `tel:${this.phone}`;
    },

    address() {
      return this.formatAddress(this.selectedEvent);
    },
    specialClient() {
      return this.selectedEvent?.client?.isSpecial
        ? '<b>Client Special:</b> ' + this.selectedEvent?.client?.specialNotes
        : '';
    },
    displayCurrentMonth() {
      const months = [
        'Ianuarie',
        'Februarie',
        'Martie',
        'Aprilie',
        'Mai',
        'Iunie',
        'Iulie',
        'August',
        'Septembrie',
        'Octombrie',
        'Noiembrie',
        'Decembrie',
      ];
      const activDay = this.$store.state.tasks.activeDay || new Date();
      const monthIndex = new Date(activDay).getMonth();
      return months[monthIndex];
    },
  },

  created() {
    // set calendar view depending on permission role
    this.type = PERMISSION_LEVEL_ADMIN === this.$store.getters['auth/getRole'] ? 'week' : 'day';
  },

  methods: {
    ...mapMutations('tasks', ['updateActiveDay', 'updateTask']),

    async getEvents({ start, end }) {
      this.$refs.calendar.scrollToTime('08:00');

      await this.$store.dispatch('tasks/getTasks', {
        startAt: new Date(`${start.date}T00:00:00`),
        endAt: new Date(`${end.date}T23:59:59`),
      });

      const { tasks } = this.$store.state.tasks;

      this.events = tasks.map((task) => {
        return {
          ...task,
          color: task.color || task.user?.color || '#000000',
          name: task.title,
          start: new Date(task.startAt).getTime(),
          end: new Date(task.endAt).getTime(),
          timed: true,
          more: true,
        };
      });
    },

    getEventColor(event) {
      return event.color;
    },
    editItem() {
      this.selectedOpen = false;
      setTimeout(() => {
        this.$router.push({ path: `/tasks/${this.selectedEvent.id}` });
      }, 0);
    },
    gotoClient() {
      this.selectedOpen = false;
      setTimeout(() => {
        this.$router.push({ path: `/clients/${this.selectedEvent.clientId}` });
      }, 0);
    },
    gotoCreateClient() {
      this.selectedOpen = false;
      setTimeout(() => {
        this.$router.push({ path: '/clients/create' });
      }, 0);
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    startTime(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;

        this.dragTime = mouse - start;
      } else {
        // here we create another task
        this.createStart = this.roundTime(mouse);

        const endAt = new Date(this.createStart);
        endAt.setHours(endAt.getHours() + 1);

        this.updateTask({
          ...TaskStoreModel,
          startAt: new Date(this.createStart),
          endAt: new Date(endAt),
        });

        this.$router.push({ path: '/tasks/create' });
      }
    },

    mouseMove(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;

        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max;

        if (this.createEvent) {
          this.updateEvent(this.createEvent);
        }
      }
    },

    startDrag({ event, timed }) {
      if (event && timed) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },

    endDrag() {
      if (this.dragEvent) {
        this.updateEvent(this.dragEvent);
      }

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },

    extendBottom(event) {
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
    },

    toTime(tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime();
    },

    roundTime(time, down = true) {
      const roundTo = 60; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down ? time - (time % roundDownTime) : time + (roundDownTime - (time % roundDownTime));
    },

    updateEvent(event) {
      this.$store.dispatch('tasks/updateTask', {
        id: event.id,
        body: {
          startAt: new Date(event.start),
          endAt: new Date(event.end),
        },
      });
    },

    formatAddress(event) {
      return (
        event?.address ||
        (event.client &&
          `${event.client.addressDetails},\n ${event.client.street},\n ${event.client.county}`)
      );
    },

    intervalFormatter(locale) {
      return locale.time;
    },

    goToPickedDate() {
      this.updateActiveDay(this.pickedDate);
      this.dateDialog = false;
    },
  },
};
</script>

<style scoped>
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}

.v-event-drag-bottom::after {
  display: none;
  position: absolute;
  left: 50%;
  height: 4px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  width: 16px;
  margin-left: -8px;
  opacity: 0.8;
  content: '';
}

.v-event-drag-bottom:hover::after {
  display: block;
}

.v-calendar {
  overflow: unset;
}

.v-calendar /deep/ .v-calendar-daily__head {
  position: sticky;
  top: 64px;
  background-color: white;
  z-index: 1;
}

@media screen and (max-width: 768px) {
  .v-calendar /deep/ .v-calendar-daily__head {
    top: 56px !important;
  }
}
</style>
